import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-socket',
  templateUrl: './socket.component.html',
  styleUrls: ['./socket.component.css']
})
export class SocketComponent implements OnInit {

  @Input() values;
  switch_state = true;
  @Output() chosen = new EventEmitter();

  constructor() { }

  ngOnInit() {
    const lang = navigator.language;
    if (lang === 'en-US' || lang === 'jp') {
      this.switch_state = false;
      const i = this.switch_state ? 1 : 0;
      this.chosen.emit(this.values[i]);
    }
  }

  switchIt() {
    this.switch_state = !this.switch_state;
    const i = this.switch_state ? 1 : 0;
    this.chosen.emit(this.values[i]);
  }
}



// WEBPACK FOOTER //
// ./src/app/socket/socket.component.ts